export const notUndefined = (value: unknown): boolean => value !== undefined && value !== null;

export const validNrOfDecimalPoints = (value: number | undefined, max: number): boolean => {
  if (value === undefined) return false;
  const decimalPoints = value.toString().split('.')[1];
  return decimalPoints ? decimalPoints.length <= max : true;
};
